module.exports = __webpack_public_path__ + "img/Web-1980.75809d8e.jpg";